import { NgModule } from '@angular/core';
import { CacheHouseLocalStorage } from './cachehouse.localstorage';
import { CacheHouseIndexDB } from './cachehouse.indexdb';
import { CacheHouseProvider } from './cachehouse.provider';

const CacheHouseFactory = (localStorage: CacheHouseLocalStorage, indexDB: CacheHouseIndexDB) => {
  return indexDB;
};

@NgModule({
  providers: [
    CacheHouseLocalStorage,
    CacheHouseIndexDB,
    {
      provide: CacheHouseProvider,
      useFactory: CacheHouseFactory,
      deps: [CacheHouseLocalStorage, CacheHouseIndexDB],
      multi: false,
    },
  ],
})
export class CacheHouseProviderModule {}
